import { Button, PageTitle, Paragraph } from '@common/components';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useNavigate } from 'react-router-dom';
import { StyledActionsContainer, StyledContainer, StyledContent } from './common.styles';

const NotFoundScreen: FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <StyledContainer>
      <StyledContent>
        <PageTitle data-testid="not-found-page-title">{t('not_found_page.title')}</PageTitle>
        <Paragraph data-testid="not-found-page-description">{t('not_found_page.description')}</Paragraph>
        <StyledActionsContainer>
          <Button
            id="not-found-page-button"
            onClick={() => {
              navigate(-1);
            }}
          >
            {t('not_found_page.action')}
          </Button>
        </StyledActionsContainer>
      </StyledContent>
    </StyledContainer>
  );
};

export default NotFoundScreen;
